import { fetcher } from '@commenda/utils';

export type BulkUnsubscribeFromServiceRequestsParams = {
  serviceRequestIds: string[];
};

export type BulkUnsubscribeFromServiceRequestsResponse = {
  unsubscribedThreadCount: number;
};

type BulkUnsubscribeFromServiceRequestsResult = {
  success: boolean;
  data?: BulkUnsubscribeFromServiceRequestsResponse;
  error?: string;
  statusCode?: number;
};

export async function bulkUnsubscribeFromServiceRequests({
  serviceRequestIds,
}: BulkUnsubscribeFromServiceRequestsParams): Promise<BulkUnsubscribeFromServiceRequestsResult> {
  try {
    const response = await fetcher('chatRoom/unsubscription/bulk', {
      method: 'POST',
      body: { serviceRequestIds },
    });

    if (!response.ok) {
      const responseData = await response.json();
      return {
        success: false,
        error: responseData?.message || 'Failed to unsubscribe from threads',
        statusCode: response.status,
      };
    }

    const responseData: BulkUnsubscribeFromServiceRequestsResponse =
      await response.json();
    return {
      success: true,
      data: responseData,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error
        ? error.message
        : 'Failed to unsubscribe from threads';
    return {
      success: false,
      error: errorMessage,
      statusCode: 500,
    };
  }
}
